module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-05.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-05.png
// module id = 1380
// module chunks = 0